import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { camps } from '../../models/models.generated';
import { CampEnrollmentApiService } from '../../services/api/camp-enrollment-api.service';



@Component({
    selector: 'app-camp-enrollment',
    templateUrl: './camp-enrollment.component.html',
    styleUrls: ['./camp-enrollment.component.scss'],
    standalone: false
})
export class CampEnrollmentComponent implements OnInit {

    public searchForm: UntypedFormGroup;
    public isBusy: boolean = false;
    public searchText: string;
    public searchFields: string[] = ['name', 'clubName'];

    public camp: camps.CampEnrollmentInfo;
    public sessions: camps.CampEnrollmentSessionInfo[];

    constructor(private activatedRoute: ActivatedRoute
        , private formBuilder: UntypedFormBuilder
        , private enrollmentApiService: CampEnrollmentApiService) { }

    ngOnInit() {

        this.initForm();

        this.activatedRoute.params.subscribe(params => {
            if (params.id) {

                this.enrollmentApiService.get(params.id).subscribe(response => {
                    this.camp = response.value;
                    this.searchForm.controls['campId'].setValue(params.id);
                });
            }
        });
    }

    private initForm() {
        this.searchForm = this.formBuilder.group({
            'campId': [null, []],
            'clubCodes': [[], []],
            'categories': [[], []],
            'agesInMonths': [[], []],
            'weeks': [[], []],
        });

        this.searchForm.valueChanges
            .pipe(debounceTime(500))
            .subscribe(() => {
                this.search();
            });
    }

    private search(): void {

        let criteria = this.prepareCriteria();

        console.log(criteria);

        this.isBusy = true;

        this.enrollmentApiService.sessions(criteria).subscribe(response => {
            this.sessions = response.value.sessions;
            this.isBusy = false;
        }, () => { this.isBusy = false; });
    }

    private prepareCriteria(): camps.CampEnrollmentSessionsSearchRequest {
        let criteria = <camps.CampEnrollmentSessionsSearchRequest>{
            campId: this.searchForm.controls['campId'].value,
            clubs: this.searchForm.controls['clubCodes'].value,
            categories: this.searchForm.controls['categories'].value,
            agesInMonths: this.searchForm.controls['agesInMonths'].value,
            weeks: this.searchForm.controls['weeks'].value
        };

        return criteria;
    }
}
